export default "__VITE_ASSET__CRwWUMc0__"